export default __webpack_public_path__ + "static/media/MoonIcon.4082c607.svg";